import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const TopBar = ({ title, showBack = false, action = null }) => {
  const navigate = useNavigate();

  return (
    <div 
      className="w-full h-16 bg-[#128C7E] text-white flex items-center px-4 sticky top-0 z-50 shadow-sm"
      data-testid="top-bar"
    >
      {showBack && (
        <button
          onClick={() => navigate(-1)}
          className="mr-3"
          data-testid="back-button"
        >
          <ArrowLeft size={24} />
        </button>
      )}
      <h1 className="text-xl font-bold flex-1" data-testid="top-bar-title">{title}</h1>
      {action}
    </div>
  );
};
